/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EScholarshipStatus } from "../types/EScholarshipStatus.ts";

/**
 * @description 1 = Interested | 2 = InProcess | 3 = ScholarshipHolder | 4 = Refused | 5 = RefusedInterested | 6 = RefusedPotential |
 */
export const eScholarshipStatusSchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
  ])
  .describe(
    "1 = Interested | 2 = InProcess | 3 = ScholarshipHolder | 4 = Refused | 5 = RefusedInterested | 6 = RefusedPotential | ",
  ) as unknown as ToZod<EScholarshipStatus>;
